export default __webpack_public_path__ + "static/media/RegistryOn.0d5ae908.svg";